import { Close, Search } from '@mui/icons-material';
import { Grid, InputAdornment, TextField } from '@mui/material';
import { ChangeEvent, FC } from 'react';
import { usePeriods } from '../../hooks/usePeriods';

interface Props {
  onSearch: (search: string) => void;
}

export const SearchPeriod: FC<Props> = ({ onSearch }) => {
  const { search, changeSearch } = usePeriods();

  const handleSearchPeriodChange = ({
    target: { name, value },
  }: ChangeEvent<HTMLInputElement>) => {
    changeSearch(value);
    onSearch(value);
  };

  const filterCleaning = () => {
    if (search === '') {
      return;
    }
    changeSearch('');
    onSearch('');
  };

  return (
    <Grid item xs={12} md={6}>
      <TextField
        label="Buscar"
        variant="outlined"
        fullWidth
        size={'small'}
        value={search}
        sx={{ py: 1 }}
        onChange={handleSearchPeriodChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end" style={{ cursor: 'pointer' }}>
              <Close onClick={filterCleaning} />
            </InputAdornment>
          ),
        }}
      />
    </Grid>
  );
};
